<div class="print-efficiency-report flex items-center justify-center">
  <table class="efficiency-report">
    <thead>
      <tr>
        <th>Play</th>
        <th *ngFor="let col of columnDefs">{{ col.headerName }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rowData">
        <!-- Play name -->
        <td class="play-cell">{{ row.play_call }}</td>

        <!-- Dynamic efficiency cells -->
        <td
          *ngFor="let col of columnDefs"
          [ngClass]="getEfficiencyClass(row[col.field], col.headerName, row.play_call)"
        >
          <div class="cell">
            <div *ngIf="row[col.field]?.total_plays > 0" class="cell-height">
              <span style="font-weight: bold">
                {{ row[col.field].total_plays }}
              </span>
              &nbsp;({{ row[col.field].wins }}/{{
                row[col.field].total_plays - row[col.field].wins
              }})<br />
              EFF:
              {{ row[col.field].pct === null ? '-' : (row[col.field].pct | number: '1.1-1') + '%' }}
            </div>
            <div *ngIf="!row[col.field]?.total_plays">-</div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
